export class TranscodingProfile {
  constructor(
    public id: number,
    public name: string,
    public isClustered: boolean = false,
  ) {}
}
